<input
  #search
  matInput
  [attr.disabled]="searchPlaceholder === 'Loading...' ? 'disabled' : null"
  name="keyword"
  [placeholder]="searchPlaceholder"
  [(ngModel)]="keyword"
  (blur)="searchActive = false"
  (focus)="searchActive = true"
  (keyup)="handleTyping()"
  />
@if (keyword || (searchPlaceholder !== 'Loading...' && searchPlaceholder !== 'Search')) {
  <button
    (click)="search.focus(); handleClearClick()"
    class="clear-button"
    >
    ✕
  </button>
  }<br>
  @if (keyword) {
    <main
      [ngStyle]="{ left: left + 'px', top: top + 'px', width: width + 'px' }"
      >
      @for (option of foundOptions; track option) {
        <button
          (click)="handleLocationClick(option)"
          >
          {{ option.tag }}: {{ option.name }}
        </button>
      }
    </main>
  }
